import { Button, Css, ModalBody, ModalFooter, ModalHeader, useModal, useTestIds } from "@homebound/beam";
import { StatusIndicator } from "src/components/StatusIndicator";
import { BidPackageStatus } from "src/generated/graphqlTypes";

/** Explains what each bid package status means. */
export function BidPackageStatusesModal() {
  const { closeModal } = useModal();
  const tid = useTestIds({}, "bidPackageStatuses");
  return (
    <>
      <ModalHeader>Bid Package Statuses</ModalHeader>
      <ModalBody>
        <ul css={Css.listReset.df.fdc.gap3.$}>
          {bidPackageStatusDescriptions.map(({ code, name, description }) => (
            <li key={code} {...tid.status}>
              <div css={Css.df.aic.gap1.$}>
                <StatusIndicator status={code} type="BidPackage" />
                <span css={Css.smSb.$}>{name}</span>
              </div>
              <p css={Css.xs.gray700.mtPx(4).$}>{description}</p>
            </li>
          ))}
        </ul>
      </ModalBody>
      <ModalFooter>
        <Button label="Done" onClick={closeModal} />
      </ModalFooter>
    </>
  );
}

const bidPackageStatusDescriptions: { code: BidPackageStatus; name: string; description: string }[] = [
  {
    code: BidPackageStatus.Amending,
    name: "Awarded • Amending",
    description:
      "A trade has been awarded, and revisions have been made since that have not been re-awarded. The original award stays active until the package is re-awarded.",
  },
  {
    code: BidPackageStatus.Awarded,
    name: "Awarded",
    description: "A trade has been awarded. Its costs now count in the budget.",
  },
  {
    code: BidPackageStatus.Received,
    name: "Bids Received",
    description: "Costs have been entered for at least one trade. No trade has been awarded yet.",
  },
  {
    code: BidPackageStatus.Open,
    name: "Bidding Open",
    description: "Setup is complete. Trades can be sent the bid or have costs entered.",
  },
  {
    code: BidPackageStatus.Draft,
    name: "Draft",
    description: "Setup is not complete. The package is not ready to send to trades.",
  },
];
